export enum RoleType {
  SHIPPER = 'SHIPPER',
  AGENT = 'AGENT',
}
